import React from 'react';

export const WorkToggle = ({ value, onToggle }: { value: boolean; onToggle: () => void }) => {
    return (
        <div
            className={`w-[56px] h-[32px] rounded-full p-[3px] flex items-center cursor-pointer transition-colors duration-300 ${
                value ? 'bg-[#3D73DD]' : 'bg-[#E6E8EA]'
            }`}
            onClick={onToggle}
        >
            <div
                className={`w-[26px] h-[26px] rounded-full bg-white shadow-[0px_0px_4px_1px_rgba(0,0,0,0.08)] transition-transform duration-300 ${
                    value ? 'translate-x-[24px]' : 'translate-x-0'
                }`}
            />
        </div>
    );
};
